(function() {
  $(function() {
    document.querySelectorAll('script[data-mega-menu-config]').forEach(function(configNode) {
      var config;
      try {
        config = JSON.parse(configNode.textContent);
      } catch (e) {
        return;
      }

      var content = $("#shopify-section-" + config.sectionId + " .mega-menu");
      var parent = $(".main-menu [data-parent='" + config.parentHandle + "']");
      if (!content.length || !parent.length) return;

      parent.addClass('has-dropdown mega-menu-trigger').attr('aria-haspopup', 'true').find('.submenu').remove();
      parent.append(content);

      if (config.customHighlight === true) {
        parent.addClass('mega-menu-custom-highlight');
        if (config.customHighlightColor) {
          parent.get(0).style.setProperty('--mega-menu-custom-highlight-color', config.customHighlightColor);
        }
      }
    });

    if (typeof window.setupDropdownMenus === 'function') {
      window.setupDropdownMenus();
    }

    $('.actual-mega-link').off('click.megaMenusStorage').on('click.megaMenusStorage', function() {
      var selectorName = '.' + $(this).attr('class').split(' ')[0];
      localStorage.setItem('lastClickedSelector', selectorName);
    });
  });
})();
